var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icons_-_Mockup",
    width: 24,
    height: 24,
    "data-name": "Icons - Mockup",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Frame",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Create_Group",
    "data-name": "Icon - Create Group",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Frame-2",
    d: "M0 0H16V16H0z",
    className: "prefix__cls-1",
    "data-name": "Frame"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_404",
    d: "M0 0L0 13",
    className: "prefix__cls-2",
    "data-name": "Line 404",
    transform: "translate(8 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_405",
    d: "M0 0L0 13",
    className: "prefix__cls-2",
    "data-name": "Line 405",
    transform: "rotate(90 3.25 11.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlus);
export default __webpack_public_path__ + "static/media/icons-plus.c6e2e4a499a3d0d6d94b732a790fa484.svg";
export { ForwardRef as ReactComponent };